// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"318":"9c6d346b","606":"d79b80c8","929":"f2f4089a"}[chunkId] + ".chunk.css";
};